export const scrollToBottom = () => {
  const mlistElement = document.getElementsByClassName("rce-mlist")[0];
  if (typeof mlistElement !== "undefined") {
    mlistElement.scrollTop = mlistElement.scrollHeight;
  }
};
